import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ArticleComponent } from './article/article.component';
import { CoverageComponent } from './coverage/coverage.component';
import { ExpertAnsComponent } from './expert-ans/expert-ans.component';
import { ExpertAskComponent } from './expert-ask/expert-ask.component';
import { LearningCenterComponent } from './learning-center/learning-center.component';
import {RouterModule, Routes} from '@angular/router';
import { SlickCarouselModule } from 'ngx-slick-carousel';
const  myRouts: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'article', component: ArticleComponent },
  { path: 'coverage', component: CoverageComponent },
  { path: 'expertAns', component: ExpertAnsComponent },
  { path: 'expertAsk', component: ExpertAskComponent },
  { path: 'learningCenter', component: LearningCenterComponent },

];


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ArticleComponent,
    CoverageComponent,
    ExpertAnsComponent,
    ExpertAskComponent,
    LearningCenterComponent,

  ],
  imports: [
    BrowserModule,
    CarouselModule,
    RouterModule.forRoot(myRouts),
    SlickCarouselModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
